export const productList = [
	{
		id: 1,
		nombre: "Napolitana",
		precio: 350,
		imagen: "/images/1.jpg",
		stock: 28,
		detalle: "La pizza napolitana, de masa tierna y delgada pero bordes altos, es la versión propia de la cocina napolitana de la pizza redonda. El término pizza napoletana, por su importancia histórica o regional, se emplea en algunas zonas como sinónimo de pizza tonda (‘pizza redonda’). Bajo la denominación pizza napoletana verace artigianale (‘pizza napolitana auténtica artesanal’) está reconocida como producto agroalimentario tradicional italiano.",
	},
	{
		id: 2,
		nombre: "Mozzarella",
		precio: 280,
		imagen: "/images/2.jpg",
		stock: 30,
		detalle: "La pizza de mozzarella es la más clásica entre todas las recetas de pizzas. Es la que nos gusta a la mayoría. Es una receta compuesta por una masa baja y crocante con una cubierta de salsa de tomate, mozzarella, aceitunas y orégano.",
	},
	{
		id: 3,
		nombre: "Vegetariana",
		precio: 240,
		imagen: "/images/3.jpg",
		stock: 37,
		detalle: "Las opciones sin carne se han vuelto muy populares en la mayoría de las cocinas. La pizza vegetariana, un pastel italiano sin carne al horno, es una opción para vegetarianos, aquellos que pueden tener una dieta con necesidades especiales, o simplemente para aquellos que buscan una alternativa más saludable a la pizza normal. La pizza vegetariana presenta los mismos quesos, condimentos y salsas que la pizza normal, aunque la carne se reemplaza con vegetales y sustitutos de la carne.",
	},
	{
		id: 4,
		nombre: "Keto",
		precio: 300,
		imagen: "/images/4.jpg",
		stock: 20,
		detalle: "Para quienes eligen llevar una dieta keto o cetogénica en la cual los hidratos deben reducirse al máximo, hoy dejamos una receta que muchos repetirán con frecuencia en su casa, se trata de una pizza keto con base de pollo. Quienes son amantes de las pizzas, sin duda echarán de menos su consumo mientras llevan una dieta keto, por eso, hoy tenemos una alternativa saludable, baja en hidratos.",
	},
	{
		id: 5,
		nombre: "Sin Gluten",
		precio: 400,
		imagen: "/images/5.jpg",
		stock: 17,
		detalle: "Nuestro mejor sabor, de la mano de nuestro equipo de nutricionistas y cheffs ahora te ofrecemos esta versión de la mejor pizza pero sin gluten. Probala sin miedo, nosotros ya nos hemos encargado de todo para que solo debas preocuparte de disfrutar al maximo tus próximos mordiscos.",
	},
	{
		id: 6,
		nombre: "Pepperoni",
		precio: 360,
		imagen: "/images/6.jpg",
		stock: 37,
		detalle: "",
	},
	{
		id: 7,
		nombre: "Cuatro quesos",
		precio: 400,
		imagen: "/images/7.jpg",
		stock: 40,
		detalle: "",
	},
	{
		id: 8,
		nombre: "Colombo especial",
		precio: 490,
		imagen: "/images/8.jpg",
		stock: 47,
		detalle: "",
	},
    {
		id: 9,
		nombre: "Agridulce",
		precio: 470,
		imagen: "/images/9.jpg",
		stock: 18,
		detalle: "",
	},
    {
		id: 10,
		nombre: "Morrones",
		precio: 300,
		imagen: "/images/10.jpg",
		stock: 20,
		detalle: "",
	},
    {
		id: 11,
		nombre: "Pollo",
		precio: 480,
		imagen: "/images/11.jpg",
		stock: 47,
		detalle: "",
	},
    {
		id: 12,
		nombre: "Vegana",
		precio: 350,
		imagen: "/images/12.jpg",
		stock: 18,
		detalle: "",
	},
    {
		id: 13,
		nombre: "Salami",
		precio: 280,
		imagen: "/images/13.jpg",
		stock: 50,
		detalle: "",
	},
    {
		id: 14,
		nombre: "Camarones",
		precio: 650,
		imagen: "/images/14.jpg",
		stock: 15,
		detalle: "",
	},
];
